import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Col, Row, Divider, Avatar, Typography, Skeleton } from 'antd';
import { RadarChartOutlined } from '@ant-design/icons';
import ParseHTML from 'html-react-parser';

import { ThemeContext } from '../Context/ThemeContext';
import { ExploreContext } from '../Context/ExploreContext';

import Parser from './Parser';
import { ProfileContext } from '../Context/ProfileContext';

const { Text, Paragraph } = Typography;

const ExploreUser = () => {
  const history = useHistory();
  const { theme } = useContext(ThemeContext);
  const { profile } = useContext(ProfileContext);
  const { users, usersLoader, followUser } = useContext(ExploreContext);

  const skeletions = [...Array(5).keys()].map((i) => {
    return (
      <div key={i}>
        <Row justify='center' align='middle'>
          <Col xs={4} sm={2} lg={4}>
            <Skeleton
              loading={usersLoader}
              paragraph={false}
              title={false}
              active
              avatar={{
                shape: 'circle',
                active: true,
              }}
            />
          </Col>
          <Col xs={14} sm={8} lg={8}>
            <Skeleton
              loading={usersLoader}
              active
              title={false}
              avatar={false}
              paragraph={{
                rows: 2,
              }}
            />
          </Col>
          <Col xs={6} sm={2} lg={4}>
            <Skeleton
              loading={usersLoader}
              title
              paragraph={false}
              active
              avatar={false}
            />
          </Col>
        </Row>
        <Divider />
      </div>
    );
  });

  return (
    <div>
      {usersLoader ? (
        skeletions
      ) : users.length > 0 ? (
        users.map((item) => {
          return (
            <div key={item.app_profile_uid}>
              <Row justify='center' align='middle'>
                <Col xs={4} sm={2} md={2} lg={2}>
                  <Avatar
                    icon={
                      <img
                        src={item.user.picture.replace('s96-c', 's512-c', true)}
                        alt={item.user.name.fullName}
                      />
                    }
                  />
                </Col>
                <Col xs={14} sm={12} md={14} lg={14}>
                  <Text
                    style={{
                      color: theme.content.text,
                      textAlign: 'left',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      history.push(`/${item.app_profile_uid}`);
                    }}
                    strong
                  >
                    {item.user.name.fullName} <br />
                    <Text
                      type='secondary'
                      style={{
                        padding: 0,
                        fontSize: '12px',
                        color: theme.content.secondaryText,
                      }}
                    >
                      {item.isPrivate ? 'Restricted Account' : 'Public Account'}
                      &nbsp;&bull;&nbsp;{item.user.bio}
                      {/* &bull; {item.user.followers} {item.user.followers===1?'follower':'followers'} */}
                    </Text>
                  </Text>
                </Col>
                <Col
                  xs={6}
                  sm={10}
                  md={8}
                  lg={8}
                  style={{
                    color: theme.header.text,
                    textAlign: 'right',
                  }}
                >
                  {item.user.uid !== profile.userData.user.uid ? (
                    item.user.current_user_follows ? (
                      <Button
                        size='small'
                        type='primary'
                        onClick={() => {
                          followUser(item.app_profile_uid);
                        }}
                      >
                        Following
                      </Button>
                    ) : (
                      <Button
                        size='small'
                        onClick={() => {
                          followUser(item.app_profile_uid);
                        }}
                      >
                        Follow
                      </Button>
                    )
                  ) : null}
                </Col>
              </Row>
              {item.article ? (
                <Row justify='center' align='middle'>
                  <Col xs={4} sm={2} md={2} lg={2} />
                  <Col xs={20} sm={22} md={22} lg={22}>
                    <Paragraph
                      style={{
                        color: `${theme.content.text}`,
                        fontSize: '20px',
                        paddingTop: '1rem',
                      }}
                    >
                      {ParseHTML(Parser(item.article.description))}
                    </Paragraph>

                    <Text
                      style={{
                        color: theme.content.text,
                      }}
                      type='secondary'
                    >
                      {new Date(item.article.createdAt).toLocaleTimeString(
                        'en-US',
                        {
                          hour: 'numeric',
                          minute: 'numeric',
                          hour12: true,
                        }
                      )}{' '}
                      &nbsp;&bull;&nbsp;
                      {new Date(item.article.createdAt).toDateString()}
                    </Text>
                  </Col>
                </Row>
              ) : null}
              <Divider />
            </div>
          );
        })
      ) : (
        <Row>
          <Col
            xs={24}
            style={{
              padding: '2rem',
              color: theme.content.text,
              textAlign: 'center',
            }}
          >
            <RadarChartOutlined
              style={{
                padding: '2rem',
                fontSize: '5rem',
              }}
            />{' '}
            <br />
            <Text
              style={{
                color: theme.content.text,
              }}
            >
              No users found! <br />
              <br />
              You must start engaging with the community to get the most out of
              it.
            </Text>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default ExploreUser;
